require('./walletTab.scss');

const PropTypes = require('prop-types');

//@ vendors
const React = require('react');
const moment = require('moment');
const uniqueId = require('lodash/utility/uniqueId');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { ContentBox } = require('commonsComponents/contentBox');
const GeoZoneBreakdown = require('components/broker/brokerGeoZoneBreakdown/brokerGeoZoneBreakdown');
const AssetsDistributionChart = require('components/d3Components/assetsDistributionChart/assetsDistributionChart');
const MorningstarStyleBox = require('components/d3Components/morningstarStyleBox/morningstarStyleBox');
const { EmptyState } = require('commonsComponents/emptyState');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { formatVolume } = require('utilities/stringHelper');

const {
    DATE_FORMAT_ES,
    BROKER_WALLET_TAB_VALUE,
    BROKER_WALLET_TAB_TYPE
} = require('constants/index');

class WalletTab extends React.Component {
    getAssetValue(assetAllocations, column, type) {
        const columnAsset = assetAllocations.find(asset => asset.get('SalePosition') === column);
        if (columnAsset && columnAsset.size && columnAsset.get('BreakdownValues')) {
            const BreakdownValue = columnAsset
                .get('BreakdownValues')
                .find(bdValue => bdValue.get('Type') === type);
            if (BreakdownValue && BreakdownValue.size && BreakdownValue.get('Value')) {
                const value = parseFloat(BreakdownValue.get('Value'));
                if (!isNaN(value)) {
                    return formatVolume(value.toFixed(2)) + '%';
                }
            }
        }

        return formatVolume(0) + '%';
    }

    getAssetsAllSection(etfProduct) {
        const assetAllocations = etfProduct.get('assetAllocations');
        return (
            <div className="assetsall-capitalization">
                <div className="broker-product-file-tabs-wallet-tab__section-subtitle">
                    {formatText('broker-walletTabAssetsAllTitle')}
                </div>
                {this.getAssetsAllTable(assetAllocations)}
            </div>
        );
    }

    getAssetsAllTable(assetAllocations) {
        return (
            <OKTable id="wallet-assets-all" className="wallet-tab__table">
                <OKTableRow>
                    <OKTableCell
                        asHeader={true}
                        className="wallet-tab__table-assets-all-cell--first-column"
                        colSpan={2}
                    >
                        {formatText('broker-walletTabAsset')}
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="wallet-tab__table-assets-all-cell">
                        {formatText('broker-walletTabAssetLong')}
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="wallet-tab__table-assets-all-cell">
                        {formatText('broker-walletTabAssetShort')}
                    </OKTableCell>
                    <OKTableCell
                        asHeader={true}
                        className="wallet-tab__table-assets-all-cell--last-column"
                    >
                        {formatText('broker-walletTabAssetNet')}
                    </OKTableCell>
                </OKTableRow>
                {this.buildAssetAllRows(assetAllocations)}
            </OKTable>
        );
    }

    getMarketCapitalizationSection(etfsProduct) {
        const marketCapitalBreakDown = etfsProduct.get('marketCapitalBreakDown');
        return (
            <div className="market-capitalization">
                <div className="broker-product-file-tabs-wallet-tab__section-subtitle">
                    {formatText('broker-walletTabMarketCapitalizationTitle')}
                </div>
                {this.getMarketCapitalizationTable(marketCapitalBreakDown)}
            </div>
        );
    }

    getMarketCapitalizationTable(marketCapitalBreakDown) {
        return (
            <OKTable id="wallet-market-capitalization" className="wallet-tab__table">
                <OKTableRow>
                    <OKTableCell
                        asHeader={true}
                        className="wallet-tab__table-market-capitalization-cell--first-column"
                    />
                    <OKTableCell
                        asHeader={true}
                        className="wallet-tab__table-market-capitalization-cell__last-cell"
                    >
                        {formatText('broker-walletTabMarketCapitalizationFound')}
                    </OKTableCell>
                </OKTableRow>
                {this.buildMarketCapitalRows(marketCapitalBreakDown)}
            </OKTable>
        );
    }

    getSizeTable(etfsProduct) {
        return (
            <OKTable id="wallet-size" className="wallet-tab__table">
                <OKTableRow>
                    <OKTableCell
                        asHeader={true}
                        className="wallet-tab__table-heritage-cell--first-column"
                    />
                    <OKTableCell asHeader={true} />
                </OKTableRow>
                <OKTableRow>
                    <OKTableCell className="wallet-tab__table-heritage-cell wallet-tab__table-heritage-cell--first-column">
                        {formatText('broker-walletTabHeritageTitle')}
                    </OKTableCell>
                    <OKTableCell className="wallet-tab__table-heritage-cell wallet-tab__table-heritage-cell__last-cell">
                        {etfsProduct.get('netAssetValues').get('dayEndValue') +
                            ' ' +
                            formatCurrency(
                                etfsProduct.get('netAssetValues').get('currencyId')
                            ) +
                            ' '}
                        |
                        <b>
                            {' ' + etfsProduct.get('netAssetValues').get('dayEndDate')
                                ? DateHelper.formatDate(
                                      new Date(etfsProduct.get('netAssetValues').get('dayEndDate')),
                                      'D MMM YYYY'
                                  )
                                : null}
                        </b>
                    </OKTableCell>
                </OKTableRow>
                <OKTableRow>
                    <OKTableCell className="wallet-tab__table-heritage-cell wallet-tab__table-heritage-cell--first-column">
                        {formatText('broker-walletTabActiveFundTitle')}
                    </OKTableCell>
                    <OKTableCell className="wallet-tab__table-heritage-cell wallet-tab__table-heritage-cell__last-cell">
                        {etfsProduct.get('fundNetAssetValues').get('dayEndValue') +
                            ' ' +
                            formatCurrency(
                                etfsProduct.get('fundNetAssetValues').get('currencyId')
                            ) +
                            ' '}
                        |
                        <b>
                            {' ' + etfsProduct.get('fundNetAssetValues').get('dayEndDate')
                                ? DateHelper.formatDate(
                                      new Date(
                                          etfsProduct.get('fundNetAssetValues').get('dayEndDate')
                                      ),
                                      'D MMM YYYY'
                                  )
                                : null}
                        </b>
                    </OKTableCell>
                </OKTableRow>
            </OKTable>
        );
    }

    buildActivesTable(assetAllocations) {
        const stocksTypeL = assetAllocations.getIn(['stocks', 'typeL']);
        const stocksTypeS = assetAllocations.getIn(['stocks', 'typeS']);
        const stocksTypeN = assetAllocations.getIn(['stocks', 'typeN']);
        const obligationsTypeL = assetAllocations.getIn(['obligations', 'typeL']);
        const obligationsTypeS = assetAllocations.getIn(['obligations', 'typeS']);
        const obligationsTypeN = assetAllocations.getIn(['obligations', 'typeN']);
        const cashTypeL = assetAllocations.getIn(['cash', 'typeL']);
        const cashTypeS = assetAllocations.getIn(['cash', 'typeS']);
        const cashTypeN = assetAllocations.getIn(['cash', 'typeN']);
        const othersTypeL = assetAllocations.getIn(['others', 'typeL']);
        const othersTypeS = assetAllocations.getIn(['others', 'typeS']);
        const othersTypeN = assetAllocations.getIn(['others', 'typeN']);
        return (
            <OKTable id="wallet-global-market-breakdown">
                <OKTableRow asHeader={true}>
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell"
                    />
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--first-column"
                    >
                        {formatText('broker-etfsProductFileViewActivesHeaderFirstLabel')}
                    </OKTableCell>
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--second-column"
                    >
                        {formatText('broker-etfsProductFileViewActivesHeaderSecondLabel')}
                    </OKTableCell>
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--second-column"
                    >
                        {formatText('broker-etfsProductFileViewActivesHeaderThirdLabel')}
                    </OKTableCell>
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--second-column"
                    >
                        {formatText('broker-etfsProductFileViewActivesHeaderFourthLabel')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        <span className="broker-product-file-tabs-wallet-tab__active-drop broker-product-file-tabs-wallet-tab__active-drop--stocks" />
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewActivesHeaderStocksLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(stocksTypeL)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(stocksTypeS)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(stocksTypeN)}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        <span className="broker-product-file-tabs-wallet-tab__active-drop broker-product-file-tabs-wallet-tab__active-drop--obligations" />
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewActivesHeaderObligationsLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(obligationsTypeL)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(obligationsTypeS)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(obligationsTypeN)}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        <span className="broker-product-file-tabs-wallet-tab__active-drop broker-product-file-tabs-wallet-tab__active-drop--cash" />
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewActivesHeaderCashLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(cashTypeL)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(cashTypeS)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(cashTypeN)}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        <span className="broker-product-file-tabs-wallet-tab__active-drop broker-product-file-tabs-wallet-tab__active-drop--others" />
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewActivesHeaderOthersLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(othersTypeL)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(othersTypeS)}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {this.formatAmountElement(othersTypeN)}
                    </OKTableCell>
                </OKTableRow>
            </OKTable>
        );
    }

    buildAssetAllRows(assetAllocations) {
        const assets = {
            '1': formatText('broker-etfsAssetAllocationStocks'),
            '2': formatText('broker-etfsAssetAllocationObligations'),
            '3': formatText('broker-etfsAssetAllocationCash'),
            '4': formatText('broker-etfsAssetAllocationOthers'),
            '99': formatText('broker-etfsAssetAllocationNoClassification')
        };
        let typesProcessed = [];
        if (assetAllocations && assetAllocations.size) {
            return assetAllocations.map((asset, index) => {
                const breakDownValues = asset.get('BreakdownValues');
                return breakDownValues.map((breakDownValue, breakDownIndex) => {
                    if (typesProcessed.indexOf(breakDownValue.get('Type')) === -1) {
                        typesProcessed.push(breakDownValue.get('Type'));
                        return (
                            <OKTableRow key={'row-assets-all-' + index + breakDownIndex}>
                                <OKTableCell
                                    className="wallet-tab__table-market-capitalization-cell--first-column"
                                    colSpan={2}
                                >
                                    <div className={'line line' + breakDownValue.get('Type')} />
                                    {assets[breakDownValue.get('Type')]}
                                </OKTableCell>
                                <OKTableCell className="wallet-tab__table-market-capitalization-cell">
                                    {this.getAssetValue(
                                        assetAllocations,
                                        'L',
                                        breakDownValue.get('Type')
                                    )}
                                </OKTableCell>
                                <OKTableCell className="wallet-tab__table-market-capitalization-cell">
                                    {this.getAssetValue(
                                        assetAllocations,
                                        'S',
                                        breakDownValue.get('Type')
                                    )}
                                </OKTableCell>
                                <OKTableCell className="wallet-tab__table-market-capitalization-cell--last-column">
                                    {this.getAssetValue(
                                        assetAllocations,
                                        'N',
                                        breakDownValue.get('Type')
                                    )}
                                </OKTableCell>
                            </OKTableRow>
                        );
                    }
                });
            });
        }
    }

    buildEquityTable(equityStatistics) {
        const prospectiveEarningYield = equityStatistics
            ? equityStatistics.get('ProspectiveEarningsYield')
            : '-';
        const prospectiveBookValueYield = equityStatistics
            ? equityStatistics.get('ProspectiveBookValueYield')
            : '-';
        const prospectiveRevenueYield = equityStatistics
            ? equityStatistics.get('ProspectiveRevenueYield')
            : '-';
        const prospectiveCashFlowYield = equityStatistics
            ? equityStatistics.get('ProspectiveCashFlowYield')
            : '-';
        const prospectiveDividendYield = equityStatistics
            ? equityStatistics.get('ProspectiveDividendYield')
            : '-';
        const forecasted5YearEarningsGrowth = equityStatistics
            ? equityStatistics.get('Forecasted5YearEarningsGrowth')
            : '-';
        const forecastedEarningsGrowth = equityStatistics
            ? equityStatistics.get('ForecastedEarningsGrowth')
            : '-';
        const forecastedRevenueGrowth = equityStatistics
            ? equityStatistics.get('ForecastedRevenueGrowth')
            : '-';
        const forecastedCashFlowGrowth = equityStatistics
            ? equityStatistics.get('ForecastedCashFlowGrowth')
            : '-';
        const forecastedBookValueGrowth = equityStatistics
            ? equityStatistics.get('ForecastedBookValueGrowth')
            : '-';
        return (
            <OKTable id="wallet-global-market-breakdown">
                <OKTableRow asHeader={true}>
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--first-column"
                    />
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--second-column"
                    >
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableSecondColumn')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityBPLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(prospectiveEarningYield) !== '' ? formatAmount(prospectiveEarningYield) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityPVCLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(prospectiveBookValueYield) !== '' ? formatAmount(prospectiveBookValueYield) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityPVLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(prospectiveRevenueYield) !== '' ? formatAmount(prospectiveRevenueYield) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityPCFLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(prospectiveCashFlowYield) !== '' ? formatAmount(prospectiveCashFlowYield) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityFRDLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(prospectiveDividendYield) !== '' ? formatAmount(prospectiveDividendYield) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityCBLPLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(forecasted5YearEarningsGrowth) !== '' ? formatAmount(forecasted5YearEarningsGrowth) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityCHBLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(forecastedEarningsGrowth) !== '' ? formatAmount(forecastedEarningsGrowth) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityCVLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(forecastedRevenueGrowth) !== '' ? formatAmount(forecastedRevenueGrowth) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityCFCLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(forecastedCashFlowGrowth) !== '' ? formatAmount(forecastedCashFlowGrowth) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletEquityCVLLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(forecastedBookValueGrowth) !== '' ? formatAmount(forecastedBookValueGrowth) + '%' : '-' ||
                            formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>
            </OKTable>
        );
    }

    buildGlobalMarketBrakdownTable(globalStocksBreakdowns) {
        const basicMaterials = globalStocksBreakdowns.get('basicMaterials');
        const comunicationServices = globalStocksBreakdowns.get('communicationServices');
        const consumerCyclical = globalStocksBreakdowns.get('consumerCyclical');
        const consumerDefensive = globalStocksBreakdowns.get('consumerDefensive');
        const healthcare = globalStocksBreakdowns.get('healthCare');
        const industrials = globalStocksBreakdowns.get('industrials');
        const realState = globalStocksBreakdowns.get('realState');
        const technology = globalStocksBreakdowns.get('technology');
        const energy = globalStocksBreakdowns.get('energy');
        const financialServices = globalStocksBreakdowns.get('financialServices');
        const utilities = globalStocksBreakdowns.get('utilities');
        return (
            <OKTable id="wallet-global-market-breakdown">
                <OKTableRow
                    asHeader={true}
                    className="broker-product-file-tabs-wallet-tab__table-header"
                >
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--first-column"
                    >
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableFirstColumn')}
                    </OKTableCell>
                    <OKTableCell
                        asHeader={true}
                        className="broker-product-file-tabs-wallet-tab__table-header-cell broker-product-file-tabs-wallet-tab__table-header-cell--second-column"
                    >
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableSecondColumn')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow className="broker-product-file-tabs-wallet-tab__row-light">
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column-label">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowLabel1')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        S/N
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableBMRowLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(basicMaterials) !== '' ? formatAmount(basicMaterials) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableCCRowLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(consumerCyclical) !== '' ? formatAmount(consumerCyclical) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableFSRowLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(financialServices) !== '' ? formatAmount(financialServices) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRSRowLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(realState) !== '' ? formatAmount(realState) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow className="broker-product-file-tabs-wallet-tab__row-light">
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column-label">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowLabel2')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        S/N
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowCSLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(comunicationServices) !== '' ? formatAmount(comunicationServices) + '%' : '-' | formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowELabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(energy) !== '' ? formatAmount(energy) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowIndLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(industrials) !== '' ? formatAmount(industrials) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowTechLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(technology) !== '' ? formatAmount(technology) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow className="broker-product-file-tabs-wallet-tab__row-light">
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column-label">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowLabel3')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        S/N
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText('broker-etfsProductFileViewWalletGSBreakdownTableRowCDLabel')}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(consumerDefensive) !== '' ? formatAmount(consumerDefensive) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText(
                            'broker-etfsProductFileViewWalletGSBreakdownTableRowHealthLabel'
                        )}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(healthcare) !== '' ? formatAmount(healthcare) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>

                <OKTableRow>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell broker-product-file-tabs-wallet-tab__table-cell--first-column">
                        {formatText(
                            'broker-etfsProductFileViewWalletGSBreakdownTableRowUtilitiesLabel'
                        )}
                    </OKTableCell>
                    <OKTableCell className="broker-product-file-tabs-wallet-tab__table-cell">
                        {formatAmount(utilities) !== '' ? formatAmount(utilities) + '%' : '-' || formatText('broker-walletTabNoData')}
                    </OKTableCell>
                </OKTableRow>
            </OKTable>
        );
    }

    buildMarketCapitalRows(marketCapitalBreakDown) {
        const sizes = {
            '1': formatText('broker-walletMarketCapitalGiant'),
            '2': formatText('broker-walletMarketCapitalBig'),
            '3': formatText('broker-walletMarketCapitalMedium'),
            '4': formatText('broker-walletMarketCapitalSmall'),
            '5': formatText('broker-walletMarketCapitalMicro')
        }

        if (marketCapitalBreakDown && marketCapitalBreakDown.size) {
            const columnAsset = marketCapitalBreakDown.find(asset => asset.get('SalePosition') === 'N');
            const keys = Object.keys(sizes);
            return keys.map((sizeKey) => {
                const marketCapitalFound = columnAsset.get('BreakdownValues').find(marketCapital => marketCapital.get(BROKER_WALLET_TAB_TYPE) === sizeKey);
                let dataRow;
                if (marketCapitalFound && marketCapitalFound.get(BROKER_WALLET_TAB_VALUE) && parseFloat(marketCapitalFound.get(BROKER_WALLET_TAB_VALUE))) {
                    dataRow = formatVolume(parseFloat(marketCapitalFound.get(BROKER_WALLET_TAB_VALUE)).toFixed(2)) + '%';
                } else {
                    dataRow = formatText('broker-notAvailableData');
                }
                return (
                    <OKTableRow key={uniqueId('marketCapitalBreakDown')}>
                        <OKTableCell
                            className="wallet-tab__table-market-capitalization-cell--first-column"
                        >
                            {sizes[sizeKey]}
                        </OKTableCell>
                        <OKTableCell
                            className="wallet-tab__table-market-capitalization-cell__last-cell"
                        >
                            {dataRow}
                        </OKTableCell>
                    </OKTableRow>
                )
            })
        }
    }

    formatAmountElement(stockType) {
        if (formatAmount(stockType) && formatAmount(stockType) !== '') {
            return formatAmount(stockType) + '%';
        }
         return formatAmount(0) + '%';
    }

    render() {
        const { etfsProduct } = this.props;
        const activeSquare = etfsProduct.get('morningstarRating');
        const geozoneData = etfsProduct.get('regionalExposure');
        const globalStocksBreakdowns = etfsProduct.get('globalStockSectorBreakdown');
        const equityStatistics = etfsProduct.get('equityStatistics');
        const assetAllocations = etfsProduct.get('assetAllocationsForTable'); //wrong name
        const assetAllocationsChartData = etfsProduct.get('assetAllocationsChartData');

        const chart =
            !assetAllocationsChartData || assetAllocationsChartData.isEmpty()
                ? <EmptyState primaryText={formatText('broker-ChartNotAvailable')} iconType="nointernet-wealth"/>
                : (<AssetsDistributionChart
                    dataset={assetAllocationsChartData}
                    width={420}
                    height={310}
                  />);

        return (
            <div
                id="brokerProductFileTabsWalletTab"
                className="broker-product-file-tabs-wallet-tab">
                {/*
                    Here we are setting the with of the table to 1140px and
                    wrapping it inside a div with overflow x to create an
                    horizintal scroll.
                */}
                <div className="row" style={{ overflowX: 'auto' }}>
                    <div style={{ width: '1140px' }}>
                        <div className="col-xs-7">
                            <div className="sizeTable">
                                <div className="broker-product-file-tabs-wallet-tab__section-title">
                                    {formatText('broker-walletTabSizeTitle')}
                                </div>
                                {this.getSizeTable(etfsProduct)}
                            </div>
                            {this.getAssetsAllSection(etfsProduct)}
                            {this.getMarketCapitalizationSection(etfsProduct)}
                        </div>
                        <div className="col-xs-5">
                            <div className="broker-product-file-tabs-wallet-tab__section-title-right">
                                {formatText('broker-walletMorningStarTabTitle')}
                            </div>
                            <ContentBox
                                title={formatText('broker-morningstarStyleBoxTitle')}
                                customClassName="broker-product-file-tabs-wallet-tab__morningstar-style-box">
                                <MorningstarStyleBox
                                    width="246"
                                    height="246"
                                    activeSquare={activeSquare}
                                />
                            </ContentBox>
                        </div>
                        <div className="col-xs-7">
                            <section className="broker-product-file-tabs-wallet-tab__section">
                                <header className="broker-product-file-tabs-wallet-tab__section-header">
                                    <h2 className="broker-product-file-tabs-wallet-tab__section-title">
                                        {formatText('broker-etfsProductFileViewWalletEquityTittle')}
                                    </h2>
                                </header>
                                {this.buildActivesTable(assetAllocations)}
                            </section>
                        </div>
                        <div className="col-xs-5 broker-product-file-tabs-wallet-tab__assets-dist-chart-box">
                            {chart}
                        </div>
                        <div className="col-xs-12">
                            <ContentBox title={formatText('broker-regionBreakdown')}>
                                <GeoZoneBreakdown geoZoneData={geozoneData} />
                            </ContentBox>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <section className="broker-product-file-tabs-wallet-tab__section">
                            <header className="broker-product-file-tabs-wallet-tab__section-header">
                                <h2 className="broker-product-file-tabs-wallet-tab__section-title">
                                    {formatText('broker-etfsProductFileViewWalletGSBreakdownLabel')}
                                </h2>
                                <div className="broker-product-file-tabs-wallet-tab__date-container">
                                    <i className="icon icon-calendario broker-markets-calendar__period-icon-calendar" />
                                    <span className="broker-product-file-tabs-wallet-tab__date">
                                        {moment(globalStocksBreakdowns.get('date')).format(
                                            DATE_FORMAT_ES
                                        )}
                                    </span>
                                </div>
                            </header>
                            {this.buildGlobalMarketBrakdownTable(globalStocksBreakdowns)}
                        </section>
                    </div>
                    <div className="col-xs-12">
                        <section className="broker-product-file-tabs-wallet-tab__section">
                            <header className="broker-product-file-tabs-wallet-tab__section-header">
                                <h2 className="broker-product-file-tabs-wallet-tab__section-title">
                                    {formatText('broker-etfsProductFileViewWalletEquityTittle')}
                                </h2>
                            </header>
                            {this.buildEquityTable(equityStatistics)}
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}

WalletTab.propTypes = {
    etfsProduct: PropTypes.object.isRequired
};

module.exports = WalletTab;
